// The Vue build version to load with the `import` command
// (runtime-only or standalone) has been set in webpack.base.conf with an alias.
import 'bootstrap'
require('../static/js/app.min.js')
import 'datatables.net'
require('@/../static/js/dataTables.bootstrap.js')
import Vue from 'vue'
import App from './App'
import router from './router'
import VueConfig from 'vue-config'
import VueI18n from 'vue-i18n'
import Translations from '@/i18n_translations.js'
import Configs from './config'
import VueHtml5Editor from 'vue-html5-editor'
import * as VueGoogleMaps from 'vue2-google-maps'
import VueProgressBar from 'vue-progressbar'
import Notifications from 'vue-notification'

Vue.use(VueI18n)

const i18n = new VueI18n({
  locale: 'pt',
  messages: Translations
})

Vue.config.productionTip = false
Vue.use(VueConfig, Configs)
Vue.use(VueHtml5Editor, {
  showModuleName: true,
  image: {
    sizeLimit: 512 * 1024,
    compress: true,
    width: 500,
    height: 500,
    quality: 80
  },
  hiddenModules: [
    'full-screen'
  ]
})
Vue.use(VueGoogleMaps, {
  load: {
    key: 'AIzaSyCcLej7e0XowuzLDp8ur4K_-_lR1p4UhN8'
  }
})

Vue.use(VueProgressBar, {
  color: '#B1D3E7',
  failedColor: '#874b4b',
  thickness: '5px',
  transition: {
    speed: '0.3s',
    opacity: '0.6s',
    termination: 300
  },
  autoRevert: true,
  location: 'top',
  inverse: false
})

Vue.use(Notifications)

/* eslint-disable no-new */
new Vue({
  el: '#app',
  router,
  template: '<App/>',
  components: { App },
  i18n
})



// WEBPACK FOOTER //
// ./src/main.js